import { gql } from '@apollo/client';
import { notificationFragment } from '../queries/notification';

export const NOTIFICATION_FOLLOW = gql`
  mutation notificationFollow($input: NotificationFollowInput!) {
    follow(input: $input) {
      success
      message
    }
  }
`;

export const NOTIFICATION_UNFOLLOW = gql`
  mutation notificationUnfollow($input: NotificationFollowInput!) {
    unfollow(input: $input) {
      success
      message
    }
  }
`;

export const LOAD_MORE_NOTIFICATIONS = gql`
  mutation moreNotifications($from: String!, $categories: [NotificationCategory!]) {
    notifications(from: $from, categories: $categories) {
      ...NotificationWithData
    }
  }
  ${notificationFragment}
`;
